import { mediaUrl } from "../../data/site";
import { Reveal, Eyebrow } from "./Reveal";

export const Gallery = ({ photos = [] }) => {
  if (!photos.length) return null;
  return (
    <section id="gallery" data-testid="gallery-section" className="px-4 py-24 sm:px-8 sm:py-32 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow num="—">Gallery</Eyebrow>
          <h2 className="mt-6 font-display text-5xl uppercase leading-[0.9] sm:text-7xl">The <span className="font-serif-i normal-case text-[var(--cash)]">camp</span></h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {photos.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <figure data-testid={`gallery-photo-${p.id}`} className="group relative aspect-[4/5] overflow-hidden rounded-[24px] border border-[var(--line)]">
                <img src={mediaUrl(p.url)} alt={p.title || "Money Alwayz photo"} loading="lazy"
                  className="h-full w-full object-cover grayscale transition-[filter,transform] duration-700 group-hover:scale-105 group-hover:grayscale-0" />
                {p.title && <figcaption className="absolute inset-x-0 bottom-0 bg-[linear-gradient(to_top,rgba(7,7,7,0.9),transparent)] p-5 font-display text-xl uppercase">{p.title}</figcaption>}
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
